module.exports = "/assets/data/fbff68e22d381af25cff776f2d9d56a1-ST14.data.json";